<template>
  <a-pagination
    class="ant-table-pagination"
    v-model="pageNum"
    :page-size-options="pageSizeOptions"
    :total="total"
    show-size-changer
    :page-size="pageSize"
    @showSizeChange="onShowSizeChange"
    @change="currentPageChange"
  >
    <template slot="buildOptionText" slot-scope="props">
      <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
      <span v-if="props.value === '50'">全部</span>
    </template>
  </a-pagination>
</template>
<script>

import request from '@/utils/request'

export default {
  data () {
    return {
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      pageNum: 1,
      pageSize: this.pageParams.pageSize || 10,
      total: 0,
      query: {}
    }
  },
  props: {
    pageParams: {
      type: Object,
      default: () => ({
        automatic: true,
        pageUrl: "",
        tableLoading: false,
        pageSize: undefined
      })
    }
  },
  created () {
    if (this.pageParams.automatic) {
      this.getFirstPage()
    }
  },
  methods: {
    // 第一页数据
    getFirstPage (query) {
      this.query = query
      this.pageNum = 1
      this.getData()
    },
    // 数据请求
    getData () {
      this.pageParams.tableLoading = true
      this.$emit('update:pageParams', this.pageParams) // 列表加载状态

      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.query
      }
      request({ url: this.pageParams.pageUrl,
        method: 'get',
        params: params
      }).then(res => {
        this.pageParams.tableLoading = false
        this.$emit('update:pageParams', this.pageParams) // 列表加载状态

        this.total = res.total || res.data && res.data.total || 0
        this.$emit("getList", res.rows || res.data) // 列表数据
      })
    },
    /** pageSize 变化的回调 */
    onShowSizeChange (pageNum, pageSize) {
      this.pageNum = pageNum
      this.pageSize = pageSize
      this.getData()
    },
    /** 页码改变的回调 */
    currentPageChange (pageNum, pageSize) {
      this.pageNum = pageNum
      this.pageSize = pageSize
      this.getData()
    }
  }
}
</script>
